<template lang="pug">
el-dialog(v-dialogDrag title="选择人员" :visible.sync="personChooseDialog" width="1000px" append-to-body @close="closeDialog")
  .personContent
    el-tabs(v-model="peopleType" @tab-click="getInitdata")
      el-tab-pane(v-for="item in navlist" :label="item.label" :name="item.name" :key="item.name")
    //- 专业人员
    .chooseContent(v-if="peopleType==='1'")
      .select
        el-form(:model="filter" inline size="small")
          el-form-item
            el-input(v-model="filter.text" size="small" placeholder="输入关键字进行过滤" clearable)
          el-form-item(v-if="canFilterByRole")
            el-select(v-model="filter.roleIds" size="small" placeholder="请选择角色" filterable multiple)
              el-option(v-for="item in sysData" :key="item.roleID" :label="item.roleName" :value="item.roleID")
          el-form-item
            el-button(type="primary" size="small" @click="handleFilter") 筛 选
            el-button(size="small" @click="handleReset") 重 置
      splitpanes.default-theme.containerHeight(:dbl-click-splitter="false")
        pane.column-left(min-size="20",size="25")
          el-tree.filter-tree(
            v-if="orgTree.length>0"
            ref="deptree"
            :data="orgTree"
            highlight-current
            :props="defaultProps"
            :filter-node-method="filterNode"
            :default-expanded-keys="defaultExpandedKeys"
            node-key="deptId" check-strictly
            @node-click="handleNodeClick" v-slot="{ node, data }")
            .labelList
              img(:src="require('@/CommonDP/assets/doc/folderChild.png')" :alt="data.isSpec ? '专业图片' : '角色图片'" )
              span {{data.deptName}}
        pane.column-right(min-size="70" size="75")
          el-table(
            ref="multipleTable"
            :data="userList"
            border
            size="small" height="400px"
            @selection-change="selectChange")
            el-table-column(type="selection" width="42" header-align="center" align="center" :selectable="judgeSelect")
            el-table-column(show-overflow-tooltip align="center" label="姓名" prop="fullName" sortable v-slot="{row}")
              span {{ row.fullName }}{{ row.isHead ? '【负责人】' : '' }}
            el-table-column(show-overflow-tooltip align="center" label="账号" prop="userName" sortable)
            el-table-column(show-overflow-tooltip align="center" label="性别" prop="gender" sortable v-slot="{row}")
              span(v-if="row.gender === '1'") 男
              span(v-if="row.gender === '2'") 女
            el-table-column(show-overflow-tooltip prop="orgName" align="center" label="所在部门" sortable)
            el-table-column(show-overflow-tooltip prop="spec" align="center" label="专业" sortable)
          .page
            el-pagination(
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageIndex"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="page.pageSize"
              :layout="page.pageLayout"
              :total="page.totalCount")
    //- 系统角色
    .chooseContent(v-if="peopleType==='2'")
      el-input(v-model="filterTextSys" size="small" placeholder="输入关键字进行过滤" clearable)
      el-tree.treeList.filter-tree(
        ref="systree"
        node-key="roleID"
        :data="sysData"
        :props="defaultRoleProps"
        :filter-node-method="filterNode2" show-checkbox
        @check="checkNodeChange" v-slot="{ node, data }" )
        .labelList
          img(:src="roleIcon" alt="角色图片" )
          span {{data.roleName}}
    //- 专业角色
    .chooseContent(v-if="peopleType==='3'")
      el-input(v-model="filterTextRole" size="small" placeholder="输入关键字进行过滤" clearable)
      el-tree.treeList.filter-tree(
        ref="roletree"
        node-key="roleId"
        :data="roleData"
        :props="defaultRoleProps"
        :filter-node-method="filterNode2" show-checkbox
        @check="checkNodeChange" v-slot="{ node, data }" )
        .labelList
          img(:src="data.isSpec ? specIcon : roleIcon" :alt="data.isSpec ? '专业图片' : '角色图片'")
          span {{data.roleName}}
    //- 项目角色
    .chooseContent(v-if="peopleType==='4'")
      el-input(v-model="filterTextProjectRole" size="small" placeholder="输入关键字进行过滤" clearable)
      el-tree.treeList.filter-tree(
        ref="projectTree"
        node-key="roleID"
        :data="projectRoleData"
        :props="defaultRoleProps"
        :filter-node-method="filterNode2" show-checkbox
        @check="checkNodeChange" )
    //- 部门标签
    .chooseContent(v-if="peopleType==='5'")
      el-input(v-model="filterTagRole" size="small" placeholder="输入关键字进行过滤" clearable)
      el-tree.treeList.filter-tree(
        ref="tagTree"
        node-key="tagId"
        :data="tagData"
        :props="tagRoleProps"
        :filter-node-method="filterNodeTag" show-checkbox
        @check="checkNodeChange" v-slot="{ node, data }")
        .labelList
          img(:src="tagIcon" alt="部门标签")
          span {{data.tagName}}
    //- 部门
    .chooseContent(v-if="peopleType==='6'")
      el-input(v-model="filterOrgRole" size="small" placeholder="输入关键字进行过滤" clearable)
      el-tree.filter-tree(
        ref="orgTree"
        :data="orgTree"
        :props="defaultProps"
        check-strictly
        :filter-node-method="filterNodeOrg"
        :default-expanded-keys="defaultExpandedKeys"
        show-checkbox
        node-key="deptId"
        @check="checkNodeChange" v-slot="{ node, data }")
        .labelList
          img(:src="require('@/CommonDP/assets/doc/folderChild.png')" :alt="data.isSpec ? '专业图片' : '角色图片'" )
          span {{data.deptName}}
  span.dialog-footer(slot="footer")
    el-button(size="small" @click="closeDialog") 取 消
    el-button(type="primary" size="small" @click="peopleDetermine") 确 定
</template>

<script>
/**
 * 人员选择，该组件不加人员的回显设置，调用改组件时，请自己本身做好判断
 */
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import { mapState } from "vuex";
import flowService from "@/CommonDP/service/flow-service";
export default {
  name: "ChoosePeople",
  components: { Splitpanes, Pane },
  props: {
    transfer: { type: String, default: "" },
    // 已经选择的人员列表
    usersList: { type: Array, default: () => [] },
    // 默认 true, 控制选择人员下的 按角色筛选下拉框；
    canFilterByRole: { type: Boolean, default: true },
    // 默认 true, 控制选择系统角色这个 tab 的显示、隐藏；
    canSelectSystemRole: { type: Boolean, default: true },
    // 默认 true, 控制选择专业角色这个 tab 的显示、隐藏；
    canSelectspecRole: { type: Boolean, default: true },
    // 默认 true, 控制选择项目角色这个 tab 的显示、隐藏；
    canSelectprojectRole: { type: Boolean, default: true },
    // 默认 true, 控制选择标签管理这个 tab 的显示、隐藏；
    canSelectTagRole: { type: Boolean, default: true },
    // 默认 true, 控制选择部门管理这个 tab 的显示、隐藏；
    canSelectOrgRole: { type: Boolean, default: true }
  },
  data () {
    return {
      personChooseDialog: false,
      peopleNavList: [
        { label: "人员", name: "1" },
        { label: "系统角色", name: "2" },
        { label: "专业角色", name: "3" },
        { label: "项目角色", name: "4" },
        { label: "标签", name: "5" },
        { label: "部门", name: "6" }
      ],
      peopleType: "1",
      filterTextSys: "",
      filterTextRole: "",
      filterTextProjectRole: "",
      filterTagRole: "",
      filterOrgRole: "",
      sysData: [], // 角色列表
      roleData: [], // 专业角色
      projectRoleData: [], // 项目角色
      tagData: [], // 部门标签
      filter: {
        text: "",
        roleIds: []
      },
      orgTree: [],
      defaultProps: {
        children: "children",
        label: "deptName"
      },
      defaultRoleProps: {
        children: "children",
        label: "roleName"
      },
      tagRoleProps: {
        children: "children",
        label: "tagName"
      },
      userList: [],
      specIcon: require("@/CommonDP/assets/doc/spec.png"),
      roleIcon: require("@/CommonDP/assets/doc/role.png"),
      tagIcon: require("@/CommonDP/assets/org/tag.png"),
      curDept: {},
      defaultExpandedKeys: [],
      page: {
        pageIndex: 1,
        pageSize: 20,
        totalCount: 0,
        pageLayout: "total, sizes, prev, pager, next, jumper"
      },
      roleSelectList: [] // 选中的人员列表
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId,
      userInfo: state => state.user.userInfo,
      routerParams: state => state.projectMg.routerParams
    }),
    // 标签页的显隐
    navlist() {
      const list = this.peopleNavList.map(row => {
        if (this.canFilterByRole && row.label === "人员") {
          return row;
        } else if (this.canSelectSystemRole && row.label === "系统角色" && !this.transfer) {
          return row;
        } else if (this.canSelectspecRole && row.label === "专业角色" && !this.transfer) {
          return row;
        } else if (this.canSelectprojectRole && row.label === "项目角色" && !this.transfer) {
          return row;
        } else if (this.canSelectTagRole && row.label === "标签" && !this.transfer) {
          return row;
        } else if (this.canSelectOrgRole && row.label === "部门" && !this.transfer) {
          return row;
        } else {
          return ;
        }
      }).filter(ele => ele);
      return [...list];
    }
  },
  watch: {
    filterTextSys(val) {
      this.$refs.systree.filter(val);
    },
    filterTextRole(val) {
      this.$refs.roletree.filter(val);
    },
    filterTextProjectRole(val) {
      this.$refs.projectTree.filter(val);
    },
    filterTagRole(val) {
      this.$refs.tagTree.filter(val);
    },
    filterOrgRole(val) {
      this.$refs.orgTree.filter(val);
    }
  },
  methods: {
    // 打开弹框
    openDialog() {
      if (this.navlist.length === 0) {
        this.$message.info("该企业未配置人员选择");
        return;
      }
      this.peopleType = this.navlist[0].name;
      this.getInitdata();
      this.personChooseDialog = true;
    },
    // 初始化 和 标签页点击事件
    getInitdata() {
      const navDsecribe = {
        "1": async() => {
          this.page.pageIndex = 1;
          await this.getSysList();
          await this.getOrgList();
          await this.$nextTick();
          this.$refs.multipleTable.clearSelection();
        },
        "2": async() => {
          await this.getSysList();
          await this.$nextTick();
          this.$refs.systree.setCheckedKeys([]);
        },
        "3": async() => {
          this.getRoleList();
          await this.$nextTick();
          this.$refs.roletree.setCheckedKeys([]);
        },
        "4": async() => {
          this.queryRoleListFlow();
          await this.$nextTick();
          this.$refs.projectTree.setCheckedKeys([]);
        },
        "5": async() => {
          this.queryTagList();
          await this.$nextTick();
          this.$refs.tagTree.setCheckedKeys([]);
        },
        "6": async() => {
          this.getOnlyOrgList();
          await this.$nextTick();
          this.$refs.orgTree.setCheckedKeys([]);
        }
      };
      navDsecribe[this.peopleType]();
    },
    // 已经选择的人员默认不可选择
    judgeSelect(row, index) {
      return !this.usersList.some(e => e.userId === row.id); // 返回true该行可选，返回false则不可选
    },
    // 系统 角色
    async getSysList() {
      const res = await flowService.querySysRoleList(this.enterpriseId);
      const array = res.data || [];
      const list = this.usersList.filter(e => e.type === 1) || [];
      const checkKeys = list.map(e => e.roleID) || [];
      this.sysData = array.map(row => {
        return {
          ...row,
          disabled: checkKeys.some(e => e === row.roleID)
        };
      });
    },
    // 部门 人员
    async getOrgList() {
      if (this.orgTree?.length) return;
      const res = await flowService.getPersonChooseOrgTree(this.enterpriseId);
      this.orgTree = res.data;
      if (res.data && res.data.length > 0) {
        this.defaultExpandedKeys.push(res.data[0].deptId);
      }
      this.getOrgPerson();
    },
    async getOnlyOrgList() {
      const res = await flowService.getPersonChooseOrgTree(this.enterpriseId);
      if (res.data && res.data.length > 0) {
        this.defaultExpandedKeys.push(res.data[0].deptId);
      }
      const array = res.data || [];
      const list = this.usersList.filter(e => e.type === 5) || [];
      const checkKeys = list.map(e => e.deptId) || [];
      this.orgTree = this.flatModuleList(array, checkKeys);
    },
    // 扁平化树形结构添加数据
    flatModuleList(val, checkKeys) {
      const each = list => {
        for (const item of list) {
          const disabled = checkKeys.some(e => e === item.deptId);
          item.disabled = disabled;
          if (item.children && item.children.length > 0) each(item.children);
          else delete item.children;
        }
      };
      each(val);
      return val;
    },
    handleNodeClick(data) {
      this.curDept = data;
      this.getOrgPerson();
    },
    // 表格人员列表
    async getOrgPerson() {
      this.userList = [];
      const params = {
        orgId: this.curDept.deptId || this.orgTree[0].deptId, // 必填
        keyword: this.filter.text,
        sysRoleId: this.filter.roleIds,
        pageNo: this.page.pageIndex,
        pageSize: this.page.pageSize
      };
      const { data, totalCount, pageIndex } = await flowService.getPersonChooseOrgUser(params);
      this.page.pageIndex = pageIndex;
      this.page.totalCount = totalCount;
      this.userList = data;
    },
    // 换分页尺寸
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getOrgPerson();
    },
    // 翻页
    handleCurrentChange(val) {
      this.page.pageIndex = val;
      this.getOrgPerson();
    },
    // 筛选
    handleFilter() {
      this.page.pageIndex = 1;
      this.getOrgPerson();
    },
    // 重置
    handleReset() {
      this.filter = {
        text: "",
        roleIds: []
      };
      this.page.pageIndex = 1;
      this.getOrgPerson();
    },
    // 选择人员选择器
    selectChange(data) {
      this.roleSelectList = data;
    },
    // 系统角色树形结构选择器
    checkNodeChange(data, currentChecked) {
      this.roleSelectList = currentChecked.checkedNodes;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.deptName.indexOf(value) !== -1;
    },
    filterNode2(value, data) {
      if (!value) return true;
      return data.roleName.indexOf(value) !== -1;
    },
    filterNodeTag(value, data) {
      if (!value) return true;
      return data.tagName.indexOf(value) !== -1;
    },
    filterNodeOrg(value, data) {
      if (!value) return true;
      return data.deptName.indexOf(value) !== -1;
    },
    // 专业 角色
    async getRoleList() {
      // if (this.roleData.length > 0) return;
      const res = await flowService.querySpecRoleTree(this.enterpriseId);
      const array = res.data || [];
      const list = this.usersList.filter(e => e.type === 2) || [];
      const checkKeys = list.map(e => e.roleId) || [];
      if (array.length > 0) {
        array.forEach(element => {
          element.isSpec = true;
        });
      }
      this.roleData = this.dealDisabled(array, checkKeys, "roleId");
    },
    // 设置已选择的树形结构不可选中
    dealDisabled(array, checkKeys, roleId) {
      for (const iterator of array) {
        iterator.disabled = checkKeys.some(e => e === iterator[roleId]);
        if (iterator.children && iterator.children.length > 0) {
          this.dealDisabled(iterator.children, checkKeys, roleId);
        }
      }
      return array;
    },
    // 项目角色
    async queryRoleListFlow() {
      const res = await flowService.queryRoleListFlow(this.enterpriseId);
      const array = res.data || [];
      const list = this.usersList.filter(e => e.type === 3) || [];
      const checkKeys = list.map(e => e.roleID) || [];
      this.projectRoleData = array.map(row => {
        return {
          ...row,
          disabled: checkKeys.some(e => e === row.roleID)
        };
      });
    },
    async queryTagList() {
      const res = await flowService.sysTagList(this.enterpriseId);
      this.tagData = res.data;
    },
    peopleDetermine() {
      if (this.transfer && this.containsCurrentUser()) {
        this.$warn("不能选择自己！");
        this.roleSelectList = [];
      } else {
        const list = this.formatData();
        this.personChooseDialog = false;
        this.$emit("userSelected", list);
      }
    },
    formatData() {
      const typeDescribe = {
        "1": (item) => {
          return { ...item, name: item.fullName, userId: item.id, type: 0 };
        },
        "2": (item) => {
          return { ...item, name: item.roleName, userId: item.roleID, type: 1 };
        },
        "3": (item) => {
          return { ...item, name: item.roleName, userId: item.roleId, type: 2 };
        },
        "4": (item) => {
          return { ...item, name: item.roleName, userId: item.roleID, type: 3 };
        },
        "5": (item) => {
          return { ...item, name: item.tagName, userId: item.tagId, type: 4 };
        },
        "6": (item) => {
          return { ...item, name: item.deptName, userId: item.deptId, type: 5 };
        }
      };
      return this.roleSelectList.map(row => {
        return typeDescribe[this.peopleType](row);
      });
    },
    containsCurrentUser() {
      return this.roleSelectList.some(item => item.id === this.userInfo.userId);
    },
    // 关闭弹框
    closeDialog() {
      this.personChooseDialog = false;
    }
  }
};
</script>

<style lang="scss">
.splitpanes.default-theme .splitpanes__pane{
  height: 100%;
  background-color: #fff !important;
}
.el-dialog__body{
  padding: 5px 10px!important;
}
.personContent{
  height: 650px;
  overflow: hidden;
}
.chooseContent{
  width: 100%;
  height: calc(100% - 50px);
  overflow-y: auto;
}
.containerHeight{
  height: calc(100% - 50px);
  width: 100%;
}
.column-left{
  height: 100%;
  overflow-y: auto;
}
.column-right{
  height: 100%;
  display: flex;
  flex-direction: column;
  .page{
    height: 50px;
    margin-top: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
}
.labelList{
  display: flex;
  flex-direction: row;
  align-items: center;
  img{
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
}
.treeList{
  height: calc(100% - 50px);
  overflow-y: auto;
}
</style>
